export enum GuidePath {
  CreateUser = 'create-user',
  CreateOrganization = 'create-organization',
}
